import { renderStyle } from "@/pages/par-marketing/configPage/utils";
import { useMemo } from "react";
interface Props {
  content: string | undefined;
  //TODO 后续放开 检查有哪些应该配置styleData 的没有配置
  styleData: any | never;
}
const FontSetBox = (props: Props) => {
  const { content, styleData } = props;
  const style = useMemo(() => renderStyle(styleData || []), [styleData]);
  return <div style={style}>{content}</div>;
};

export default FontSetBox;
